import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Modal,
  Button,
  TextField,
} from "@mui/material";
import React, { useEffect, useState, useRef, useCallback } from "react";
import axios from "axios";
import { grey, red, blue, green, teal } from "@mui/material/colors";
import carPumpIcon from "../../icon/fire_pump_truck_marker_64px.png";
import carOffroadIcon from "../../icon/fire_offroad_pump_truck_marker_64px.png";
import carTankIcon from "../../icon/fire_water_tanker_marker_64px.png";
import carChemicalIcon from "../../icon/fire_chemical_truck_marker_64px.png";
import carRescueIcon from "../../icon/fire_rescue_truck_marker_64px.png";
import carAmbulanceIcon from "../../icon/fire_ambulance_marker_64px.png";
import carHelicopterIcon from "../../icon/fire_helicopter_marker_64px.png";
import carCommandIcon from "../../icon/fire_command_van_marker_64px.png";
import carRecoveryIcon from "../../icon/fire_recovery_truck_marker_64px.png";
import carAdminIcon from "../../icon/fire_admin_car_marker_64px.png";
import carSatelliteIcon from "../../icon/fire_satellite_van_marker_64px.png";
import carPoliceIcon from "../../icon/police_car_marker_64px.png";
import carGovernmentIcon from "../../icon/government_car_marker_64px.png";
import carVolunteerIcon from "../../icon/volunteer_fire_truck_marker_64px.png";
import carCivilianIcon from "../../icon/civilian_car_marker_64px.png";
import markerRdvIcon from "../../icon/marker-rdv.svg";
import DownloadIcon from "@mui/icons-material/Download";
import CloseIcon from "@mui/icons-material/Close";
import SmsIcon from "@mui/icons-material/Sms";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";
import diffCls from "../common/RealtimeDiff.module.css";
import {
  buildMfListDiffMap,
  mfRowKey,
  DIFF_DISPLAY_MS,
} from "../../lib/statusBoardDiff";

function getEqpIcon(mfeqp) {
  const eqp = (mfeqp || "").trim();
  if (eqp === "소방펌프") return carPumpIcon;
  if (eqp === "소방험지" || eqp.includes("험지")) return carOffroadIcon;
  if (eqp === "소방물탱크") return carTankIcon;
  if (eqp === "소방화학" || eqp.includes("화학")) return carChemicalIcon;
  if (eqp === "소방구조" || eqp.includes("구조")) return carRescueIcon;
  if (eqp === "소방구급" || eqp.includes("구급")) return carAmbulanceIcon;
  if (eqp === "소방헬기" || eqp.includes("헬기")) return carHelicopterIcon;
  if (eqp === "소방지휘" || eqp.includes("지휘")) return carCommandIcon;
  if (eqp === "소방회복" || eqp.includes("회복")) return carRecoveryIcon;
  if (eqp === "소방행정" || eqp.includes("행정")) return carAdminIcon;
  if (eqp.includes("위성")) return carSatelliteIcon;
  if (eqp.includes("경찰")) return carPoliceIcon;
  if (eqp.includes("공무원")) return carGovernmentIcon;
  if (eqp.includes("의소대")) return carVolunteerIcon;
  return carCivilianIcon; // 기타차량
}

const bcc = teal[50];
const bcd = teal[50];
let bgc = "";

const statusTitle = {
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  fontWeight: "bold",
  backgroundColor: red[900],
  color: "white",
};
const statusTitleG = {
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  fontWeight: "bold",
  backgroundColor: grey[500],
  color: "white",
};
const tblstyle = {
  fontWeight: "bold",
  backgroundColor: red[400],
  color: "white",
};
const tblstyleG = {
  fontWeight: "bold",
  backgroundColor: grey[400],
  color: "white",
};

const commandStyle = {
  maxWidth: "150px",
  whiteSpace: "normal",
  wordBreak: "break-word",
};

const excelbtn = {
  width: 30,
  height: 25,
  border: "solid 1px yellow",
  borderRadius: 3,
  "&:hover": {
    backgroundColor: green[300],
    pointer: "cursor",
  },
  zIndex: 10,
  marginRight: "5px",
  marginLeft: "20px",
};

const closebtn = {
  width: 30,
  height: 25,
  border: "solid 1px yellow",
  borderRadius: 3,
  "&:hover": {
    backgroundColor: red[300],
    pointer: "cursor",
  },
  zIndex: 10,
  marginTop: "3px",
  marginLeft: "5px",
  marginRight: "20px",
};

let tmp;

const LightTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.white,
    color: "rgba(0, 0, 0, 0.87)",
    boxShadow: theme.shadows[1],
    fontSize: 12,
  },
}));

const isMobile = () => {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent,
  );
};

const getStatusInfo = (status) => {
  const statusMap = {
    0: { text: "대기", color: green[300] },
    1: { text: "이동", color: blue[300] },
    2: { text: "활동", color: red[300] },
    3: { text: "복귀", color: grey[500] },
    9: { text: "집결중", color: grey[500] },
  };
  return statusMap[status] || { text: "기타", color: grey[500] };
};

const formatPhoneNumber = (phoneNumber) => {
  if (!phoneNumber) return "";
  const numbers = phoneNumber.replace(/\D/g, "");
  if (numbers.length === 11) {
    return `${numbers.slice(0, 3)}-${numbers.slice(3, 7)}-${numbers.slice(7)}`;
  }
  return phoneNumber;
};

/** 상태 변경 시각 — changestatus는 mfeddt, QR 등은 mfchdt 갱신 */
const getStatusChangeTime = (row) =>
  row?.mfchdt || row?.mfeddt || row?.mfipdt || "";

const getTimeDiff = (statusChangeTime) => {
  if (!statusChangeTime) return "";

  const now = new Date();
  const mfTime = new Date(statusChangeTime);
  const diffInMinutes = Math.floor((now - mfTime) / (1000 * 60));

  if (diffInMinutes < 60) {
    return `${Math.max(0, diffInMinutes)}M`;
  }
  const hours = Math.floor(diffInMinutes / 60);
  const minutes = diffInMinutes % 60;
  return `${hours}H ${minutes}M`;
};

const MF_DETAIL_HEADER_PX = 40;
/** 상황판 live 갱신과 동일 — 상태 변경 직후 API 반영 대기 */
const STATE_SYNC_REFETCH_MS = 400;
const MF_DETAIL_LAYOUT_GAP_PX = 8;
/** 지령/상태 이력 패널 DOM 없을 때: bottom 16 + 축소 높이 36 */
const MISSION_HISTORY_COLLAPSED_TOP_OFFSET = 16 + 36;

function sortMfList(rows) {
  return [...rows].sort((a, b) => {
    const timeA = new Date(getStatusChangeTime(a)).getTime() || 0;
    const timeB = new Date(getStatusChangeTime(b)).getTime() || 0;
    // 최근 상태 변경이 위로
    return timeB - timeA;
  });
}

function mergeStatusChangeTimes(serverRows, localRows) {
  if (!localRows?.length) return serverRows;
  return serverRows.map((row) => {
    const local = localRows.find((r) => {
      if (row.snum != null && r.snum != null && String(r.snum) === String(row.snum)) {
        return true;
      }
      if (
        row.seqnum != null &&
        r.seqnum != null &&
        String(r.seqnum) === String(row.seqnum)
      ) {
        return true;
      }
      return false;
    });
    if (!local) return row;
    const localTime = new Date(getStatusChangeTime(local)).getTime() || 0;
    const serverTime = new Date(getStatusChangeTime(row)).getTime() || 0;
    if (localTime <= serverTime) return row;
    return {
      ...row,
      mfchdt: local.mfchdt || row.mfchdt,
      mfeddt: local.mfeddt || row.mfeddt,
    };
  });
}

const MobilizedPowerPanel = (props) => {
  // 상황판 하단에 바로 붙이기: DOM 실제 위치(뷰포트 기준) 사용
  const [panelTop, setPanelTop] = useState(70);
  const [tableMaxHeight, setTableMaxHeight] = useState(360);

  const [orgmfdata, setorgmfData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [orderModalOpen, setOrderModalOpen] = useState(false);
  const [orderModalItem, setOrderModalItem] = useState(null);
  const [orderInputValue, setOrderInputValue] = useState("");
  const [orderSubmitting, setOrderSubmitting] = useState(false);
  const [statusFilter, setStatusFilter] = useState("all"); // 'all' | 0 | 1 | 2 | 3 | 9
  const [smsModalOpen, setSmsModalOpen] = useState(false);
  const [smsModalItem, setSmsModalItem] = useState(null);
  const [smsPhoneInput, setSmsPhoneInput] = useState("");
  const [smsSubmitting, setSmsSubmitting] = useState(false);
  const [mfListDiff, setMfListDiff] = useState({});
  const prevMfRef = useRef([]);
  const mfDiffTimerRef = useRef(null);
  const selectionRef = useRef({ org: "", eqp: "" });
  const silentRefreshTimerRef = useRef(null);
  const timelineMfRef = useRef({ active: false });

  const scheduleDiffClear = useCallback(() => {
    if (mfDiffTimerRef.current) clearTimeout(mfDiffTimerRef.current);
    mfDiffTimerRef.current = setTimeout(() => {
      setMfListDiff({});
      mfDiffTimerRef.current = null;
    }, DIFF_DISPLAY_MS);
  }, []);

  const applyLocalStatusPatch = useCallback(
    (detail) => {
      const ondsid = (sessionStorage.ondsid || "").trim();
      const dsid = (detail?.dsid || "").trim();
      if (ondsid && dsid && dsid !== ondsid) return false;
      const mfstatus = detail?.mfstatus;
      if (mfstatus == null) return false;

      const base = prevMfRef.current;
      if (!base.length) return false;

      const idx = base.findIndex((r) => {
        if (detail.snum != null && String(r.snum) === String(detail.snum)) {
          return true;
        }
        if (
          detail.seqnum != null &&
          String(r.seqnum) === String(detail.seqnum)
        ) {
          return true;
        }
        return false;
      });
      if (idx < 0) return false;

      const now = new Date().toISOString().slice(0, 19).replace("T", " ");
      const next = [...base];
      next[idx] = {
        ...next[idx],
        mfstatus: Number(mfstatus),
        mfchdt: now,
        mfeddt: now,
      };
      const sorted = sortMfList(next);
      setMfListDiff(buildMfListDiffMap(base, sorted));
      scheduleDiffClear();
      prevMfRef.current = sorted;
      setorgmfData(sorted);
      return true;
    },
    [scheduleDiffClear],
  );

  const getselectedorgmflist = useCallback(
    async (withDiff = false, options = {}) => {
      const { silent = false } = options;
      try {
        if (!silent) setIsLoading(true);
        const orgFromSession = sessionStorage.selectedOrg ?? "";
        const eqpFromSession = sessionStorage.selectedEqp ?? "";
        if (orgFromSession !== "" || eqpFromSession !== "") {
          selectionRef.current = { org: orgFromSession, eqp: eqpFromSession };
        }
        const org = orgFromSession || selectionRef.current.org;
        const eqp = eqpFromSession || selectionRef.current.eqp;
        if (org === "" && eqp === "") {
          if (!silent) setorgmfData([]);
          return;
        }
        const timeline = timelineMfRef.current;
        const wstring = timeline.active
          ? `${props.apiAddr}/get/mflistattime?dsid=${encodeURIComponent(sessionStorage.ondsid)}&date=${encodeURIComponent(timeline.date)}&hour=${timeline.hour}&minute=${timeline.minute ?? 0}&org=${encodeURIComponent(org)}&eqp=${encodeURIComponent(eqp)}`
          : `${props.apiAddr}/get/selorgmflist?id=${org}&id2=${eqp}&dsid=${sessionStorage.ondsid}`;
        const result = await axios.get(wstring);

        const merged = mergeStatusChangeTimes(result.data || [], prevMfRef.current);
        const sortedData = sortMfList(merged);

        if (withDiff && prevMfRef.current.length > 0) {
          setMfListDiff(buildMfListDiffMap(prevMfRef.current, sortedData));
          scheduleDiffClear();
        } else if (!withDiff) {
          setMfListDiff({});
        }
        prevMfRef.current = sortedData;
        setorgmfData(sortedData);
      } catch (error) {
        console.error("데이터 로딩 중 오류:", error);
        if (!silent) setorgmfData([]);
      } finally {
        if (!silent) setIsLoading(false);
      }
    },
    [props.apiAddr, scheduleDiffClear],
  );

  const scheduleSilentRefresh = useCallback(() => {
    if (silentRefreshTimerRef.current) {
      clearTimeout(silentRefreshTimerRef.current);
    }
    silentRefreshTimerRef.current = setTimeout(() => {
      silentRefreshTimerRef.current = null;
      if (timelineMfRef.current.active) return;
      getselectedorgmflist(true, { silent: true });
    }, STATE_SYNC_REFETCH_MS);
  }, [getselectedorgmflist]);

  const hasOrgOrEqpSelection = () => {
    const org = (sessionStorage.selectedOrg ?? "") || selectionRef.current.org;
    const eqp = (sessionStorage.selectedEqp ?? "") || selectionRef.current.eqp;
    return org !== "" || eqp !== "";
  };

  useEffect(() => {
    const onTimelineMfList = (e) => {
      const { active, date, hour, minute } = e.detail || {};
      timelineMfRef.current = {
        active: !!active,
        date,
        hour,
        minute: minute ?? 0,
      };
      if (hasOrgOrEqpSelection()) {
        getselectedorgmflist(false, { silent: true });
      }
    };
    const onStatusChanged = (e) => {
      if (timelineMfRef.current.active) return;
      applyLocalStatusPatch(e.detail);
      scheduleSilentRefresh();
    };
    window.addEventListener("statusTimelineMfList", onTimelineMfList);
    window.addEventListener("mfStatusChanged", onStatusChanged);
    return () => {
      window.removeEventListener("statusTimelineMfList", onTimelineMfList);
      window.removeEventListener("mfStatusChanged", onStatusChanged);
    };
  }, [applyLocalStatusPatch, scheduleSilentRefresh, getselectedorgmflist]);

  useEffect(() => {
    if (!props.statechanged || timelineMfRef.current.active) return;
    scheduleSilentRefresh();
  }, [props.statechanged, scheduleSilentRefresh]);

  useEffect(
    () => () => {
      if (mfDiffTimerRef.current) clearTimeout(mfDiffTimerRef.current);
      if (silentRefreshTimerRef.current) {
        clearTimeout(silentRefreshTimerRef.current);
      }
    },
    [],
  );

  useEffect(() => {
    getselectedorgmflist(false);
  }, [props.mflist, getselectedorgmflist]);

  // 현상태 경과 시간(H/M) 자동 갱신
  useEffect(() => {
    const timer = setInterval(() => {
      setorgmfData((rows) => (rows.length ? [...rows] : rows));
    }, 60000);
    return () => clearInterval(timer);
  }, []);

  // 사인보드 클릭으로 열었을 때 해당 상태만 필터 적용
  useEffect(() => {
    if (
      props.initialStatusFilter !== undefined &&
      props.initialStatusFilter !== null
    ) {
      setStatusFilter(props.initialStatusFilter);
    }
  }, [props.initialStatusFilter]);

  // 상황판 하단 위치 + 지령/상태 이력 패널 위까지 테이블 스크롤 높이 계산 (겹침 방지)
  useEffect(() => {
    let roStatusCleanup;
    let roHistoryCleanup;
    const updateLayout = () => {
      const statusEl =
        document.getElementById("statusBoardBox") ||
        document.getElementById("statusPanel");
      const historyEl = document.getElementById("missionHistoryPanel");
      let top = 70 + MF_DETAIL_LAYOUT_GAP_PX;
      if (statusEl) {
        const srect = statusEl.getBoundingClientRect();
        top = srect.bottom + MF_DETAIL_LAYOUT_GAP_PX;
      }
      setPanelTop(top);
      const historyTop = historyEl
        ? historyEl.getBoundingClientRect().top
        : window.innerHeight - MISSION_HISTORY_COLLAPSED_TOP_OFFSET;
      const tableH = Math.max(
        120,
        Math.floor(
          historyTop -
            top -
            MF_DETAIL_LAYOUT_GAP_PX -
            MF_DETAIL_HEADER_PX,
        ),
      );
      setTableMaxHeight(tableH);
    };
    const t = setTimeout(() => {
      updateLayout();
      const statusEl =
        document.getElementById("statusBoardBox") ||
        document.getElementById("statusPanel");
      if (statusEl && typeof ResizeObserver !== "undefined") {
        const ro = new ResizeObserver(updateLayout);
        ro.observe(statusEl);
        roStatusCleanup = () => ro.unobserve(statusEl);
      }
      const historyEl = document.getElementById("missionHistoryPanel");
      if (historyEl && typeof ResizeObserver !== "undefined") {
        const roH = new ResizeObserver(updateLayout);
        roH.observe(historyEl);
        roHistoryCleanup = () => roH.unobserve(historyEl);
      }
    }, 50);
    window.addEventListener("resize", updateLayout);
    return () => {
      clearTimeout(t);
      window.removeEventListener("resize", updateLayout);
      if (roStatusCleanup) roStatusCleanup();
      if (roHistoryCleanup) roHistoryCleanup();
    };
  }, []);

  const tableToExcelExport = () => {
    try {
      if (orgmfdata.length === 0) {
        alert("내보낼 데이터가 없습니다.");
        return;
      }

      const XLSX = require("xlsx");
      const table = document.getElementById("mflistTable");
      if (!table) {
        throw new Error("테이블을 찾을 수 없습니다");
      }

      const data = Array.from(table.rows).map((row) =>
        Array.from(row.cells).map((cell) => cell.textContent.trim()),
      );

      const wb = XLSX.utils.book_new();
      const ws = XLSX.utils.aoa_to_sheet(data);
      XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
      XLSX.writeFile(wb, "동원자원현황.xlsx");
    } catch (error) {
      console.error("엑셀 변환 중 오류 발생:", error);
      alert("엑셀 파일 생성 중 오류가 발생했습니다.");
    }
  };

  const filteredOrgmfdata =
    statusFilter === "all"
      ? orgmfdata
      : orgmfdata.filter(
          (item) => Number(item.mfstatus) === Number(statusFilter),
        );

  const orgmflist = filteredOrgmfdata.map((item) => {
    const rowKey = mfRowKey(item);
    const rowDiff = rowKey ? mfListDiff[rowKey] : null;
    const rowBg = rowDiff?.isNew
      ? diffCls.rowNew
      : rowDiff?.changed
        ? diffCls.rowStatusChanged
        : undefined;
    return (
    <TableRow
      key={rowKey || item.snum || item.seqnum}
      sx={{
        "&:hover td": {
          backgroundColor: grey[200],
        },
        ...(rowBg ? { "& td": { backgroundColor: "#fff9c4" } } : {}),
        ...(rowDiff?.isNew ? { "& td": { backgroundColor: "#e8f5e9" } } : {}),
      }}
    >
      <TableCell>
        {item.mfdorg.replace(/본부|소방|안전|구조|재난|상|라|청|도|입력/g, "")}
      </TableCell>
      <TableCell sx={bcd}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
          <img
            src={getEqpIcon(item.mfeqp)}
            alt=""
            style={{
              width: 24,
              height: getEqpIcon(item.mfeqp) === markerRdvIcon ? 32 : 24,
              flexShrink: 0,
            }}
          />
          {item.mfeqp.indexOf("소방") != -1
            ? item.mfeqp.replace("소방", "")
            : item.org}
        </Box>
      </TableCell>
      <TableCell sx={bcd}>{item.mfcsgn}</TableCell>
      <TableCell align="center" bgcolor={getStatusInfo(item.mfstatus).color}>
        {getStatusInfo(item.mfstatus).text} (
        {getTimeDiff(getStatusChangeTime(item))})
        {rowDiff?.label && (
          <span
            className={diffCls.diffUp}
            style={{ display: "block", fontSize: "0.7rem" }}
          >
            {rowDiff.label}
          </span>
        )}
      </TableCell>
      <TableCell sx={bcd} align="center">
        {item.mfnm}
      </TableCell>
      <TableCell align="center">
        {isMobile() ? (
          <a
            href={`tel:${item.mfphnum}`}
            style={{
              color: "inherit",
              textDecoration: "none",
              borderBottom: "1px dotted blue",
            }}
          >
            {formatPhoneNumber(item.mfphnum)}
          </a>
        ) : (
          formatPhoneNumber(item.mfphnum)
        )}
      </TableCell>
      <TableCell align="center">{item.mfsumnum}</TableCell>
      <TableCell sx={commandStyle} align="center">
        <Box
          sx={{
            display: "flex",
            gap: 0.5,
            justifyContent: "center",
            flexWrap: "wrap",
          }}
        >
          <LightTooltip title="동원자원앱 링크 문자전송" placement="top" arrow>
            <Button
              size="small"
              variant="outlined"
              onClick={() => handleOpenSmsModal(item)}
              sx={{
                minWidth: 0,
                py: 0.2,
                px: 0.5,
                minHeight: 0,
                lineHeight: 1.2,
              }}
            >
              <SmsIcon sx={{ fontSize: "1rem" }} />
            </Button>
          </LightTooltip>
          <LightTooltip
            title={item.mforder || "문자로 지령전송"}
            placement="top"
            arrow
          >
            <Button
              size="small"
              variant="outlined"
              onClick={() => {
                setOrderModalItem(item);
                setOrderInputValue(item.mforder || "");
                setOrderModalOpen(true);
              }}
              sx={{
                textTransform: "none",
                fontSize: "0.7rem",
                maxWidth: "100%",
                py: 0.2,
                px: 0.75,
                minHeight: 0,
                lineHeight: 1.2,
              }}
            >
              지령
            </Button>
          </LightTooltip>
        </Box>
      </TableCell>
    </TableRow>
    );
  });

  const buildMfAppLinkUrl = (item) => {
    const dsid =
      (typeof sessionStorage !== "undefined" && sessionStorage.ondsid) || "";
    const seqnum = item?.seqnum;
    const hqCode =
      (typeof localStorage !== "undefined" && localStorage.hq?.trim()) || "gw";
    if (!dsid || seqnum == null || seqnum === "") return "";
    const params = new URLSearchParams({
      id: dsid,
      sq: String(seqnum),
      hq: hqCode,
    });
    return `https://mfm.119survey.org/user?${params.toString()}`;
  };

  const handleCopyMfAppLink = async () => {
    const url = buildMfAppLinkUrl(smsModalItem);
    if (!url) {
      alert("복사할 링크를 만들 수 없습니다.");
      return;
    }
    try {
      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(url);
      } else {
        const ta = document.createElement("textarea");
        ta.value = url;
        ta.style.position = "fixed";
        ta.style.left = "-9999px";
        document.body.appendChild(ta);
        ta.select();
        document.execCommand("copy");
        document.body.removeChild(ta);
      }
      alert("링크가 클립보드에 복사되었습니다.");
    } catch {
      alert("링크 복사에 실패했습니다.");
    }
  };

  const handleOpenSmsModal = (item) => {
    setSmsModalItem(item);
    setSmsPhoneInput(formatPhoneNumber(item.mfphnum) || "");
    setSmsModalOpen(true);
  };

  const handleSendSms = async () => {
    if (!smsModalItem || !props.apiAddr) return;
    const pnum = (smsPhoneInput || "").replace(/\D/g, "");
    if (!pnum || pnum.length < 10) {
      alert("올바른 휴대번호를 입력해주세요.");
      return;
    }
    const dsid =
      (typeof sessionStorage !== "undefined" && sessionStorage.ondsid) || "";
    if (!dsid) {
      alert("재난을 선택해주세요.");
      return;
    }
    setSmsSubmitting(true);
    try {
      const smsData = {
        dsid,
        seqnum: smsModalItem.seqnum,
        pnum: pnum,
        callsgn: (smsModalItem.mfcsgn || "").trim(),
        hqCode:
          (typeof localStorage !== "undefined" && localStorage.hq?.trim()) ||
          "gw",
        replyNumber: "033-249-5664",
      };
      const res = await axios.post(
        `${props.apiAddr.replace(/\/$/, "")}/post/sendsms`,
        smsData,
      );
      const data = res.data;
      if (data && data.result === "success") {
        alert("문자가 발송되었습니다.");
        setSmsModalOpen(false);
        setSmsModalItem(null);
      } else {
        alert(data?.message || "문자 발송에 실패했습니다.");
      }
    } catch (e) {
      console.warn("문자 발송 오류", e);
      alert(e.response?.data?.message || "문자 발송 중 오류가 발생했습니다.");
    } finally {
      setSmsSubmitting(false);
    }
  };

  const handleOrderSubmit = async () => {
    if (!orderModalItem || !props.apiAddr) return;
    const dsid =
      (typeof sessionStorage !== "undefined" && sessionStorage.ondsid) || "";
    if (!dsid) {
      alert("재난을 선택해주세요.");
      return;
    }
    const orderText = orderInputValue.trim();
    if (!orderText) {
      alert("지령 내용을 입력해주세요.");
      return;
    }
    setOrderSubmitting(true);
    try {
      const res = await fetch(`${props.apiAddr}/post/mforder`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          dsid,
          seqnum: orderModalItem.seqnum,
          order: orderText,
        }),
      });
      const data = await res.json();
      if (data && data.result === "success") {
        setOrderModalOpen(false);
        const now = new Date();
        const ipdt = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")} ${String(now.getHours()).padStart(2, "0")}:${String(now.getMinutes()).padStart(2, "0")}:${String(now.getSeconds()).padStart(2, "0")}`;
        if (typeof window.dispatchEvent === "function") {
          window.dispatchEvent(
            new CustomEvent("mfHistoryRowAdded", {
              detail: {
                dsid,
                row: {
                  kind: "order",
                  seqnum: orderModalItem.seqnum,
                  mfeqp: orderModalItem.mfeqp ?? "",
                  mfdorg: orderModalItem.mfdorg ?? "",
                  mfcsgn: orderModalItem.mfcsgn ?? "",
                  content: orderText,
                  ipdt,
                },
              },
            }),
          );
        }
        setOrderModalItem(null);
        getselectedorgmflist();

        // 해당 전화번호로 지령 내용 문자 전송
        const pnum = (orderModalItem.mfphnum || "").replace(/\D/g, "");
        if (pnum.length >= 10) {
          try {
            const smsData = {
              dsid,
              seqnum: orderModalItem.seqnum,
              pnum,
              callsgn: (orderModalItem.mfcsgn || "").trim(),
              hqCode:
                (typeof localStorage !== "undefined" &&
                  localStorage.hq?.trim()) ||
                "gw",
              replyNumber: "033-249-5664",
              msg: orderText,
            };
            const smsRes = await axios.post(
              `${props.apiAddr.replace(/\/$/, "")}/post/sendsms`,
              smsData,
            );
            const smsResult = smsRes.data;
            if (smsResult && smsResult.result === "success") {
              alert(
                "지령이 등록되었고, 해당 번호로 지령 내용이 문자로 전송되었습니다.",
              );
            } else {
              alert(
                "지령은 등록되었으나 문자 전송에 실패했습니다. " +
                  (smsResult?.message || ""),
              );
            }
          } catch (smsErr) {
            console.warn("지령 등록 후 문자 전송 오류", smsErr);
            alert("지령은 등록되었으나 문자 전송 중 오류가 발생했습니다.");
          }
        } else {
          alert(
            "지령이 등록되었습니다. (등록된 전화번호가 없어 문자는 발송하지 않았습니다.)",
          );
        }
      } else {
        alert("지령 등록에 실패했습니다.");
      }
    } catch (err) {
      console.error(err);
      alert("지령 등록 중 오류가 발생했습니다.");
    } finally {
      setOrderSubmitting(false);
    }
  };

  const handleClose = () => {
    if (props.onClose) {
      props.onClose();
    } else {
      sessionStorage.selectedOrg = "";
      sessionStorage.selectedEqp = "";
      selectionRef.current = { org: "", eqp: "" };
      getselectedorgmflist();
    }
    if (typeof window.dispatchEvent === "function") {
      window.dispatchEvent(new CustomEvent("mfDetailClosed"));
    }
  };

  const activeOrg =
    (sessionStorage.selectedOrg ?? "") || selectionRef.current.org;
  const activeEqp =
    (sessionStorage.selectedEqp ?? "") || selectionRef.current.eqp;
  const hasSelection = activeOrg !== "" || activeEqp !== "";
  const selectionTitle = !hasSelection
    ? "동원자원현황"
    : `동원자원현황(${
        activeOrg === "sum" ? "전체" : `${activeOrg}${activeEqp}`
      })`;

  const sidebarExpanded = props.sidebarExpanded !== false;
  const panelLeft = sidebarExpanded ? "370px" : "180px";

  return (
    <Box
      sx={{
        position: "fixed",
        zIndex: 10,
        top: panelTop,
        left: panelLeft,
        transition: "left 0.25s ease-out",
        backgroundColor: "white",
        border: "solid 1px black",
        borderRadius: "5px",
        overflow: "hidden",
        boxShadow: "0 2px 12px rgba(0,0,0,0.2)",
      }}
    >
      <Box
        sx={{
          ...(sessionStorage.oningox == 1 ? statusTitle : statusTitleG),
          alignItems: "center",
          flexWrap: "wrap",
          height: "40px",
          minHeight: "40px",
          maxHeight: "40px",
          gap: 0.5,
          // px: 0.5,
          // py: 0.5,
        }}
      >
        <LightTooltip
          title="닫기"
          placement="top"
          arrow
          style={{ marginTop: "3px", marginLeft: "5px" }}
        >
          <CloseIcon style={closebtn} onClick={handleClose} />
        </LightTooltip>
        <Typography
          variant="h6"
          textAlign="center"
          sx={{ fontWeight: "bold", flex: 1, minWidth: 120 }}
        >
          {selectionTitle}
        </Typography>
        <Box sx={{ display: "flex", gap: 0.5, alignItems: "center" }}>
          {[
            { key: "all", label: "전체", value: "all", color: grey[500] },
            { key: 9, label: "집결중", value: 9, color: grey[600] },
            { key: 0, label: "대기", value: 0, color: green[500] },
            { key: 1, label: "이동", value: 1, color: blue[500] },
            { key: 2, label: "활동", value: 2, color: red[500] },
            { key: 3, label: "복귀", value: 3, color: grey[500] },
          ].map(({ key, label, value, color }) => {
            const isSelected = statusFilter === value;
            return (
              <Button
                key={key}
                size="small"
                variant={isSelected ? "contained" : "outlined"}
                onClick={() => setStatusFilter(value)}
                sx={{
                  minWidth: 44,
                  // minHeight: 25,
                  py: 0.25,
                  fontSize: "0.8rem",
                  fontWeight: "bold",
                  color: isSelected ? "white" : "white",
                  backgroundColor: isSelected ? color : "transparent",
                  borderColor: isSelected ? color : "rgba(255,255,255,0.8)",
                  "&:hover": {
                    backgroundColor: isSelected
                      ? color
                      : "rgba(255,255,255,0.2)",
                    borderColor: isSelected ? color : "white",
                  },
                }}
              >
                {label}
              </Button>
            );
          })}
        </Box>
        <LightTooltip
          title="엑셀 저장"
          placement="top"
          arrow
          style={{ marginTop: "3px" }}
        >
          <DownloadIcon style={excelbtn} onClick={tableToExcelExport} />
        </LightTooltip>
      </Box>
      <TableContainer
        component={Paper}
        sx={{
          maxHeight: tableMaxHeight,
          overflow: "auto",
        }}
      >
        <Table
          stickyHeader
          sx={{
            minWidth: 250,
            display: { xs: "none", sm: "table" },
            "& .MuiTableCell-root": {
              padding: "4px 8px",
              fontSize: "0.8rem",
              lineHeight: 1.5,
            },
          }}
          size="small"
          aria-label="a dense table"
          id="mflistTable"
        >
          <TableHead>
            <TableRow>
              <TableCell
                sx={sessionStorage.oningox == 1 ? tblstyle : tblstyleG}
              >
                소속
              </TableCell>
              <TableCell
                sx={sessionStorage.oningox == 1 ? tblstyle : tblstyleG}
              >
                종류
              </TableCell>
              <TableCell
                sx={sessionStorage.oningox == 1 ? tblstyle : tblstyleG}
              >
                장비명
              </TableCell>
              <TableCell
                sx={sessionStorage.oningox == 1 ? tblstyle : tblstyleG}
              >
                현상태(시간)
              </TableCell>
              <TableCell
                sx={sessionStorage.oningox == 1 ? tblstyle : tblstyleG}
              >
                대표자
              </TableCell>
              <TableCell
                sx={sessionStorage.oningox == 1 ? tblstyle : tblstyleG}
              >
                전화번호
              </TableCell>
              <TableCell
                sx={sessionStorage.oningox == 1 ? tblstyle : tblstyleG}
              >
                인원
              </TableCell>
              <TableCell
                sx={sessionStorage.oningox == 1 ? tblstyle : tblstyleG}
              >
                문자 지령
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {!hasSelection && orgmfdata.length === 0 ? (
              <TableRow>
                <TableCell colSpan={9} align="center">
                  기관 또는 장비를 선택해주세요.
                </TableCell>
              </TableRow>
            ) : orgmfdata.length === 0 ? (
              <TableRow>
                <TableCell colSpan={9} align="center">
                  자료가 없습니다.
                </TableCell>
              </TableRow>
            ) : filteredOrgmfdata.length === 0 ? (
              <TableRow>
                <TableCell colSpan={9} align="center">
                  해당 상태의 자원이 없습니다.
                </TableCell>
              </TableRow>
            ) : (
              orgmflist
            )}
          </TableBody>
        </Table>
      </TableContainer>

      <Modal
        open={orderModalOpen}
        onClose={() => setOrderModalOpen(false)}
        aria-labelledby="order-modal-title"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "90%",
            maxWidth: 400,
            bgcolor: "background.paper",
            border: "2px solid #000",
            boxShadow: 24,
            p: 2,
          }}
        >
          <Typography
            id="order-modal-title"
            variant="h6"
            color="gray"
            textAlign="center"
            mb={1}
          >
            지령을 입력하면 해당 번호로 문자로 전송됩니다.
          </Typography>
          {orderModalItem && (
            <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
              {orderModalItem.mfdorg} / {orderModalItem.mfcsgn} /{" "}
              {orderModalItem.mfnm}
            </Typography>
          )}
          <TextField
            fullWidth
            multiline
            rows={3}
            placeholder="지령 내용을 입력하세요 문자로 전송됩니다."
            value={orderInputValue}
            onChange={(e) => setOrderInputValue(e.target.value)}
            size="small"
            sx={{ mb: 2 }}
          />
          <Box sx={{ display: "flex", justifyContent: "center", gap: 1 }}>
            <Button
              variant="contained"
              onClick={handleOrderSubmit}
              disabled={orderSubmitting}
            >
              등록
            </Button>
            <Button variant="outlined" onClick={() => setOrderModalOpen(false)}>
              취소
            </Button>
          </Box>
        </Box>
      </Modal>

      <Modal
        open={smsModalOpen}
        onClose={() => setSmsModalOpen(false)}
        aria-labelledby="sms-modal-title"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "90%",
            maxWidth: 400,
            bgcolor: "background.paper",
            border: "2px solid #000",
            boxShadow: 24,
            p: 2,
          }}
        >
          <Typography
            id="sms-modal-title"
            variant="h6"
            color="gray"
            textAlign="center"
            mb={1}
          >
            동원자원앱 링크 문자전송 
          </Typography>
          {smsModalItem && (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: 1,
                mb: 1,
              }}
            >
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{ flex: 1, minWidth: 0 }}
              >
                {smsModalItem.mfdorg} / {smsModalItem.mfcsgn} /{" "}
                {smsModalItem.mfnm}
              </Typography>
              <Button
                size="small"
                variant="outlined"
                onClick={handleCopyMfAppLink}
                sx={{ flexShrink: 0, whiteSpace: "nowrap" }}
              >
                링크복사
              </Button>
            </Box>
          )}
          <TextField
            fullWidth
            label="휴대번호"
            placeholder="010-1234-5678"
            value={smsPhoneInput}
            onChange={(e) => setSmsPhoneInput(e.target.value)}
            size="small"
            sx={{ mb: 2 }}
            inputProps={{ maxLength: 13 }}
          />
          <Box sx={{ display: "flex", justifyContent: "center", gap: 1 }}>
            <Button
              variant="contained"
              onClick={handleSendSms}
              disabled={smsSubmitting}
            >
              {smsSubmitting ? "발송중..." : "발송"}
            </Button>
            <Button
              variant="outlined"
              onClick={() => setSmsModalOpen(false)}
              disabled={smsSubmitting}
            >
              취소
            </Button>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
};

export default MobilizedPowerPanel;
